import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {switchMap, tap} from 'rxjs/operators';
import {AuthService} from '../../../../feature/login/services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {LoginAndRegDialogComponent} from '../../../../feature/login/components/login-and-reg-dialog/login-and-reg-dialog.component';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly matDialog: MatDialog,
    private readonly router: Router,
              ) { }

  ngOnInit() {
    this.authService.activateAccount(this.activatedRoute.snapshot.queryParams.key).pipe(tap( res => {
      this.openAuthModal();
      this.router.navigate(['']);
    })).subscribe();
  }

  public openAuthModal(): void {
    this.matDialog.open<LoginAndRegDialogComponent>(LoginAndRegDialogComponent, {width: '630px'});
  }

}
